// In src/NewsList.js

import React from 'react';
import Prismic from 'prismic-javascript';
import PropTypes from 'prop-types';
import { RichText } from 'prismic-reactjs';
import { Transition } from 'react-transition-group';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import InfiniteScroll from 'react-infinite-scroller';
import s from './NewsList.scss';
import NewsTeaser from '../NewsTeaser';
import Loader from '../Loader';

const duration = 300;

const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0,
};

const transitionStyles = {
  entering: { opacity: 0 },
  entered: { opacity: 1 },
};

const Fade = ({ in: inProp, children }) => (
  <Transition in={inProp} timeout={duration}>
    {state => (
      <ul
        className={s.newsList}
        style={{
          ...defaultStyle,
          ...transitionStyles[state],
        }}
      >
        {children}
      </ul>
    )}
  </Transition>
);

Fade.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node.isRequired).isRequired,
  in: PropTypes.bool.isRequired,
};

class NewsList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      in: false,
      currentPage: 1,
      previousPage: 0,
      news: [],
      hasMoreItems: true,
    };

    this.loadItems = this.loadItems.bind(this);
  }

  getImageUrl = image => {
    if (typeof image.teaser !== 'undefined') {
      return image.teaser.url;
    }
    return image.url;
  };

  loadItems() {
    const apiEndpoint = 'https://right2water.cdn.prismic.io/api/v2';

    // A check to see if it fires after loading new items
    const { previousPage } = this.state;
    if (previousPage < this.state.currentPage) {
      this.setState({ previousPage: this.state.currentPage });
    }

    Prismic.api(apiEndpoint).then(api => {
      api
        .query(Prismic.Predicates.at('document.type', 'news'), {
          orderings: '[my.news.publication_date desc]',
          pageSize: 12,
          page: this.state.currentPage,
        })
        .then(response => {
          if (response) {
            const totalPages = response.total_pages;

            if (
              totalPages >= this.state.currentPage &&
              previousPage === this.state.currentPage
            ) {
              this.setState({
                in: true,
                news: [...this.state.news, ...response.results],
                currentPage: this.state.currentPage + 1,
              });
            }

            if (totalPages < this.state.currentPage) {
              this.setState({ hasMoreItems: false });
            }
          }
        });
    });
  }

  render() {
    const news = [];

    this.state.news.map(newsItem =>
      news.push(
        <li key={newsItem.uid} className={s.newsList__item}>
          <NewsTeaser
            title={RichText.asText(newsItem.data.title)}
            destination={`/news/${newsItem.uid}`}
            image_url={
              newsItem.data.image && this.getImageUrl(newsItem.data.image)
            }
            date={newsItem.data.publication_date}
          />
        </li>,
      ),
    );

    return (
      <div className={s.container}>
        <InfiniteScroll
          pageStart={0}
          loadMore={this.loadItems}
          hasMore={this.state.hasMoreItems}
          loader={<Loader key={0} />}
        >
          <Fade in={this.state.in} timeout={500}>
            {news}
          </Fade>
        </InfiniteScroll>
      </div>
    );
  }
}

export default withStyles(s)(NewsList);
